module.exports = __webpack_public_path__ + "img/index-t-slide3.6a0b73ce.png";